<template>
  <div
    class="flex flex-col items-center justify-center h-full text-sm text-center xl:text-lg"
  >
    <span class="text-sm text-center loading-text text-sw_gray-600">{{ $t('general.loading') }}</span>
    <div :id="id" class="relative flex-shrink-0 w-full h-3 mt-4 bullets-9">
      <div
        v-for="(_, idx) in Array(animationWidth)"
        :id="`${id}-${idx + 1}`"
        :key="idx"
        class="absolute w-3 h-3 swiss-loading"
        :class="{ 'top-0': idx === 0 }"
      />
    </div>
    <slot />
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: {
    id: {
      type: String,
      default: 'swiss-loading',
    },
    animationWidth: {
      type: Number,
      default: 9,
    },
  },
})
</script>
